import useNavigator from "@saleor/hooks/useNavigator";
import { getSortUrlVariables } from "@saleor/utils/sort";

import {
  getNotRefChangeOrderUrl,
  getNotRefCreateOrderUrl,
  NotRefOrderSortField
} from "../urls";

const useSort = (formikItemDetail, params, toFirst, orderId, isChangeFlow) => {
  const getNotRefOrderUrl = isChangeFlow
    ? getNotRefChangeOrderUrl
    : getNotRefCreateOrderUrl;

  const navigate = useNavigator();
  const handleSort = field => {
    toFirst();

    const sortParam = getSortUrlVariables(field, params);

    const lines = [...formikItemDetail.values.lines];

    switch (sortParam.sort) {
      case NotRefOrderSortField.itemNo:
        if (sortParam.asc) {
          lines.sort(
            (itemA, itemB) => Number(itemA.itemNo) - Number(itemB.itemNo)
          );
        } else {
          lines.sort(
            (itemA, itemB) => Number(itemB.itemNo) - Number(itemA.itemNo)
          );
        }
        break;
      default:
        break;
    }

    formikItemDetail.setFieldValue("lines", lines);
    navigate(
      getNotRefOrderUrl(orderId)({
        ...getSortUrlVariables(field, params)
      }),
      {
        replace: true
      }
    );
  };

  return { handleSort };
};

export default useSort;
